import { SapImportTable } from "../component/sapImportCSV/SapImportTable";

export const TelematicsImportPage = () => {
  return (
    <>
      <SapImportTable type="TELEMATICS"/>
    </>
  );
};
